import React, { useEffect, useState } from "react";
import Drawer from "../shared/Drawer";

export default function ConnectionRequestDrawer({ open, step, onClose, onSave }) {
  const [message, setMessage] = useState("");
  const [withdrawAfterDays, setWithdrawAfterDays] = useState(0);
  const [delay, setDelay] = useState(0);
  const [delayUnit, setDelayUnit] = useState("hours");

  useEffect(() => {
    if (!step) return;
    setMessage(step.content || step.message || "");
    setWithdrawAfterDays(step.withdrawAfterDays ?? 0);
    setDelay(step.delay ?? 0);
    setDelayUnit(step.delayUnit || "hours");
  }, [step]);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title="Connection request"
      footer={
        <>
          <button type="button" onClick={onClose} className="px-4 py-2 rounded-lg border text-sm">
            Dismiss
          </button>
          <button
            type="button"
            onClick={() =>
              onSave?.({
                ...step,
                content: message,
                message,
                withdrawAfterDays: Number(withdrawAfterDays) || 0,
                delay: Number(delay) || 0,
                delayUnit,
                label: "Send connection request",
              })
            }
            className="px-4 py-2 rounded-lg bg-blue-500 text-white text-sm"
          >
            Save
          </button>
        </>
      }
    >
      <div className="space-y-4">
        <div>
          <label className="text-sm font-medium">Note (optional)</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={5}
            maxLength={300}
            className="mt-1 w-full border rounded-xl px-3 py-2 text-sm"
            placeholder="Hi {FIRST_NAME}, …"
          />
          <div className="text-xs text-gray-500 text-right">{300 - message.length} left</div>
        </div>
        <div>
          <label className="text-sm font-medium">Withdraw after (days, 0 = never)</label>
          <input
            type="number"
            min={0}
            value={withdrawAfterDays}
            onChange={(e) => setWithdrawAfterDays(e.target.value)}
            className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
          />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-sm font-medium">Delay before step</label>
            <input
              type="number"
              min={0}
              value={delay}
              onChange={(e) => setDelay(e.target.value)}
              className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
            />
          </div>
          <div>
            <label className="text-sm font-medium">Unit</label>
            <select
              value={delayUnit}
              onChange={(e) => setDelayUnit(e.target.value)}
              className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
            >
              <option value="hours">Hours</option>
              <option value="days">Days</option>
            </select>
          </div>
        </div>
      </div>
    </Drawer>
  );
}
